'use client'
import { CSSProperties } from "react";

type Props = {
  hueShift?: number;
  noiseIntensity?: number;
  scanlineIntensity?: number;
  speed?: number;
  scanlineFrequency?: number;
  warpAmount?: number;
  resolutionScale?: number;
};

type BlobDef = {
  w: string; h: string;
  top?: string; bottom?: string;
  left?: string; right?: string;
  color: string;
  blur: number;
  anim: string;
  baseDuration: number;
};

const blobs: BlobDef[] = [
  {
    w: "75%", h: "75%", bottom: "-15%", left: "-15%",
    color: "hsl(216 100% 49% / 0.65)",
    blur: 55, anim: "dv-float-1", baseDuration: 14,
  },
  {
    w: "65%", h: "65%", top: "-10%", right: "-10%",
    color: "hsl(187 100% 40% / 0.55)",
    blur: 65, anim: "dv-float-2", baseDuration: 18,
  },
  {
    w: "85%", h: "85%", top: "5%", left: "5%",
    color: "hsl(240 60% 45% / 0.45)",
    blur: 75, anim: "dv-float-3", baseDuration: 22,
  },
  {
    w: "45%", h: "45%", top: "25%", left: "25%",
    color: "hsl(187 100% 69% / 0.35)",
    blur: 40, anim: "dv-float-4", baseDuration: 11,
  },
];

function blobStyle(b: BlobDef, duration: string): CSSProperties {
  return {
    position: "absolute",
    width: b.w,
    height: b.h,
    top: b.top,
    bottom: b.bottom,
    left: b.left,
    right: b.right,
    background: `radial-gradient(ellipse, ${b.color} 0%, transparent 70%)`,
    borderRadius: "50%",
    filter: `blur(${b.blur}px)`,
    animation: `${b.anim} ${duration} ease-in-out infinite`,
    willChange: "transform",
  };
}

export default function DarkVeilCss({
  hueShift = 0,
  speed = 0.5,
}: Props) {
  return (
    <div
      className="absolute inset-0"
      style={{
        background: "hsl(var(--primary))",
        overflow: "hidden",
        filter: hueShift ? `hue-rotate(${hueShift}deg)` : undefined,
      }}
    >
      {blobs.map((b, i) => (
        <div
          key={i}
          style={blobStyle(b, `${(b.baseDuration / speed).toFixed(1)}s`)}
        />
      ))}
    </div>
  );
}
